import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { CampanhaPipelineCardInfoNaoConfirmadaComponent } from './campanha-pipeline-card-info-nao-confirmada.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CampanhaPipelineCardInfoNaoConfirmadaComponent
    ],
    exports: [
        CampanhaPipelineCardInfoNaoConfirmadaComponent
    ]
})
export class CampanhaPipelineCardInfoNaoConfirmadaModule { }
